import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, model, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type {
  OnyxOptional,
  OnyxRouteLeg,
  OnyxScheduleCompliance,
} from '@onyx/angular';
import {
  OnyxAddressComponent,
  OnyxButtonComponent,
  OnyxIconComponent,
  OnyxRouteLegType,
} from '@onyx/angular';
import { TransitHelper } from '../../../../helpers/transit.helper';
import type { RouteSubpoint } from '../../../../interfaces/route/route-subpoint';
import { RoutePointBorderComponent } from '../route-point-border/route-point-border.component';
import type { RoutePointRouteSummary } from '../route-point-route-summary/route-point-route-summary.component';
import { RoutePointRouteSummaryComponent } from '../route-point-route-summary/route-point-route-summary.component';
import { DictionaryCode } from './../../../../enums/dictionary-code';

@Component({
  selector: 'app-route-point-leg-summary',
  imports: [
    RoutePointRouteSummaryComponent,
    OnyxAddressComponent,
    TranslatePipe,
    NgTemplateOutlet,
    OnyxButtonComponent,
    OnyxIconComponent,
    RoutePointBorderComponent,
  ],
  templateUrl: './route-point-leg-summary.component.html',
  styleUrl: './route-point-leg-summary.component.scss',
})
export class RoutePointLegSummaryComponent {
  public readonly leg = input.required<OnyxRouteLeg>();
  public readonly previousLeg = input<OnyxRouteLeg | null>(null);
  public readonly isFirstLeg = input.required<boolean>();
  public readonly routeSummary = input<RoutePointRouteSummary | null>(null);
  public readonly realizationCompliance =
    input<OnyxOptional<OnyxScheduleCompliance>>(null);
  public readonly index = input.required<number>();
  public readonly subpoints = input<RouteSubpoint[]>([]);
  public readonly subpointsExpanded = input(false);
  public readonly bordersExpanded = model(false);

  protected readonly OnyxRouteLegType = OnyxRouteLegType;
  protected readonly DictionaryCode = DictionaryCode;

  protected hasRealization = signal(false);

  protected legData = computed(() => {
    const leg = this.leg();
    const previousLeg = this.previousLeg();
    const transitRoute = TransitHelper.fromRouteLeg(leg, previousLeg);

    return {
      ...leg,
      summary: {
        ...leg.summary,
        transitTypes: leg.type !== OnyxRouteLegType.VEHICLE ? [leg.type] : [],
        transitDuration: null,
        remainingTransitDuration: null,
        remainingDistance: null,
      } satisfies RoutePointRouteSummary,
      transitRoute,
    };
  });
  protected showBordersButton = computed(
    () => this.leg().passthroughs.length > 0 && !this.subpoints()?.length,
  );

  protected toggleBorders(): void {
    this.bordersExpanded.update((expanded) => !expanded);
  }
}
